import { Action } from '@ngrx/store';
import { ReportsTabs } from './state';

export enum ReportActionTypes {
  SetActiveTab = '[Reports] Set active tab'
}

export class SetActiveTab implements Action {
  public readonly type: string = ReportActionTypes.SetActiveTab;
  public readonly location: boolean = true; // ToDo: Not sure if need

  constructor(public payload: ReportsTabs) {}
}

export type ReportsActionUnion = SetActiveTab;
